import { ModuleType } from "../../queryKeyFactory";

export const historyKeyFactory = {
  history: (
    status: string,
    type: string,
    date: string,
    search: string,
    number: number
  ): [
    ModuleType,
    "notification-history",
    string,
    string,
    string,
    string,
    number
  ] => ["ux", "notification-history", status, type, date, search, number],

  runHistory: (
    status: string,
    type: string,
    date: string,
    search: string,
    number: number
  ): [ModuleType, "run-history", string, string, string, string, number] => [
    "ux",
    "run-history",
    status,
    type,
    date,
    search,
    number,
  ],

  scheduledDetails: (
    search: string,
    number: number,
    type: string,
    order: string
  ): [ModuleType, "scheduled-details", string, number, string, string] => [
    "ux",
    "scheduled-details",
    search,
    number,
    type,
    order,
  ],
  notificationDetailsForRun: (
    runId: string,
    search: string,
    page: number
  ): [ModuleType, "notification-details-for-run", string, string, number] => [
    "ux",
    "notification-details-for-run",
    runId,
    search,
    page,
  ],
};
